import { render } from "./InterestBonusInfo.vue?vue&type=template&id=d16cade8&scoped=true"
import script from "./InterestBonusInfo.vue?vue&type=script&lang=js"
export * from "./InterestBonusInfo.vue?vue&type=script&lang=js"

import "./InterestBonusInfo.vue?vue&type=style&index=0&id=d16cade8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d16cade8"]])

export default __exports__